import { createFileRoute } from '@tanstack/react-router'
import WorkGeneralSection from 'Work/components/Work/Sections/General/WorkGeneralSection'

export const Route = createFileRoute('/work/$workId/misc')({
    component: WorkGeneralSection,
})
